export const replaceItemsInString = (str: string, replacements: { [key: string]: string }) =>
  Object.keys(replacements).reduce((acc, key) => {
    const regex = new RegExp(`{${key}}`, 'g');
    return acc.replace(regex, replacements[key]);
  }, str);
